import React from 'react';
import { ShopArray } from '../../fetch/fetchInbound';
import { useShopArrayStyles } from './ShopArrayComboBox';

export function ShowShops({
  shopList,
}: {
  shopList: ShopArray[];
}): JSX.Element {
  const classes = useShopArrayStyles();

  return (
    <>
      <div className={classes.root}>
        {shopList.map((shop: ShopArray, shopIndex: number) => (
          <div key={`${shop.shopName}-${shopIndex}`} className={classes.tag}>
            {shop.shopName}
          </div>
        ))}
      </div>
    </>
  );
}
